/**
 *  @class
 *  @function BackToTop
 */
if (!customElements.get('back-to-top')) {
	class BackToTop extends HTMLElement {
	  constructor() {
			super();
			this.pageHeight = window.innerHeight;
			this.firstElement = document.querySelector('.full-menu .thb-full-menu li a');
	  }

		connectedCallback() {
			this.addEventListener('click', this.onClick);
			this.addEventListener('keydown', (event) => {
				if (event.key === 'Enter') {
					this.onClick();
				}
			});
			window.addEventListener('scroll', this.checkVisible.bind(this), {passive: true});
		}

		checkVisible(event) {
			window.requestAnimationFrame(() => {
				let y = window.scrollY;
		    if (y > this.pageHeight) {
		      this.classList.add('back-to-top--active');
		    } else {
				this.classList.remove('back-to-top--active');
			}
			});
	  }

		onClick() {
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: "smooth"
			});

			setTimeout(() => {
				this.firstElement.focus();
			}, 500);
	  }
	}
	customElements.define('back-to-top', BackToTop);
}
